import { api } from './api';

const getPendingNotifications = async ({id, customerId, vouId,  page, pageSize }) => {
    const response = await api({
        url: `Notifications/getPendingNotifications`,
        method: 'GET',
        id,
        params: {
            customerId,
            vouId,
            page,
            pageSize,
        },
    });
    return response.data;
};

const notificationsServices = {
  getPendingNotifications,
};

export default notificationsServices;
